import { model as i18n } from '!/i18n'
import {
  api,
  type GetPartnerProductsByPageParams,
  type Page,
  type PartnerProduct,
} from '@setplex/tria-api'
import { combine, createEvent, createStore, sample } from 'effector'
import { formatPartnerProductRow } from '../helpers'

export const resetPartnerProductRow = createEvent()
const partnerProductRowLoaded = createEvent<Page<PartnerProduct>>()

export const $partnerProductRow = createStore<Page<PartnerProduct> | null>(null)
  .on(partnerProductRowLoaded, (_, partnerProduct) => partnerProduct)
  .reset(resetPartnerProductRow)

export const $partnerProductRowFormatted = combine(
  $partnerProductRow,
  i18n.$t,
  (partnerProductRow) =>
    partnerProductRow && formatPartnerProductRow(partnerProductRow)
)

export const $partnerProductRowLoading =
  api.partnerProgram.getPartnerProductsByPageRowFx.pending

export const loadPartnerProductRow =
  createEvent<GetPartnerProductsByPageParams>()

sample({
  clock: loadPartnerProductRow,
  target: api.partnerProgram.getPartnerProductsByPageRowFx,
})

sample({
  clock: api.partnerProgram.getPartnerProductsByPageRowFx.doneData,
  target: partnerProductRowLoaded,
})
